module.exports = function() {
  return new Worker(__webpack_public_path__ + "ca5bff926af67b7feeb3.worker.js");
};